export function calculateInvoiceTotal(loadedItems = []) {
  return loadedItems.reduce((total, item) => {
    return total + getItemPrice(item)
  }, 0)
}

export function getItemPrice(item) {
  return Number(item?.price || 0)
}
